import React from 'react'
import { func } from 'prop-types'
import { Field } from 'formik'
import { Captcha } from './Captcha'

export function Recaptcha({ setRef, handleCaptcha }) {
  return (
    <Field
      type='hidden'
      name='captcha'
      setRef={setRef}
      returnCaptcha={handleCaptcha}
      component={Captcha}
    />
  )
}

Recaptcha.propTypes = {
  setRef: func,
  handleCaptcha: func,
}
